import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";

const SearchPrescriptions = () => {
    const searchFilters = {
        filters: [
            {
                name: "amka",
                label: "ΑΜΚΑ Ασθενή",
                type: "input",
            },
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Αρ. συνταγής",
            field: "barcode",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Αναγνωριστικό Ασθενή",
            field: "identifier",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ονοματεπώνυμο",
            field: "name",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ασφαλιστικός Φορέας",
            field: "socialInsurance",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ημ/νια έκδοσης",
            field: "issueDate",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κατάσταση Συνταγής",
            field: "status",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ημ/νια εκτέλεσης",
            field: "executionDate",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Εκτελέστηκε στην ΕΕ",
            field: "euDispensed",
            editable: false,
            hiddenColumn: true,
            inputType: {
                type: "text",
            }
        }
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search Prescriptions"}
                key={"Prescription Search Prescriptions"}
                hideYearFilter={false}
                allowOtherYears={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}

                allowSorting={false}
                allowPrintResults={true}
                dataEndpoint={"/prescription/export-prescriptions"}
                exportFileName={"Συνταγές"}
            />
        </div>
    )
}

export default SearchPrescriptions
